import { Property } from '@propertypal/shared/src/types/property';
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import { Container, OverflowCount, Pill, Rail } from './AttributePills.style';

interface Props {
  property: Property;
}

const AttributePills: FunctionComponent<Props> = (props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [hiddenCount, setHiddenCount] = useState(0);

  const measureOverflow = () => {
    const container = containerRef.current;

    if (!container) {
      return;
    }

    const containerRight = container.getBoundingClientRect().right;
    const pills = Array.from(container.querySelectorAll<HTMLElement>('[data-pill]'));

    const hidden = pills.reduce((count, pill) => {
      return pill.getBoundingClientRect().right > containerRight ? count + 1 : count;
    }, 0);

    setHiddenCount(hidden);
  };

  useEffect(() => {
    measureOverflow();

    if (containerRef.current) {
      const observer = new ResizeObserver(measureOverflow);

      observer.observe(containerRef.current);

      return () => observer.disconnect();
    }

    return () => {};
  }, []);

  if (!props.property.attributes?.length) {
    return null;
  }

  return (
    <Container ref={containerRef} data-testid="attribute-pills">
      <Rail>
        {props.property.attributes.map((attribute) => (
          <Pill key={attribute.id} data-pill data-testid="attribute-pill">
            {attribute.text}
          </Pill>
        ))}
      </Rail>

      {hiddenCount > 0 && <OverflowCount data-testid="attribute-pills-overflow">+{hiddenCount} more</OverflowCount>}
    </Container>
  );
};

export default AttributePills;
